import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner } from 'elements'
import { formSubmit } from 'utils/form'
import { getCamera, updateCamera } from 'redux/modules/model/camera'
import { cameraDetailsSelector, cameraDetailsStatusSelector } from 'redux/selectors'
import { CameraForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'


const COMPONENT_CSS_CLASSNAME = 'camera-edit'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class CameraEdit extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    getCamera: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    camera: PropTypes.object,
    cameraDetailsStatus: PropTypes.string.isRequired,
    updateCamera: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { getCamera, match: { params: { cameraSn, targetClientId } } } = this.props
    var clientId = targetClientId
    getCamera({ clientId, cameraSn })
  }

  handleSubmit = (values) => {
    const { clientId, history, camera, updateCamera } = this.props
    const targetClientId = get(camera, 'clientId');
    const cameraSn = get(camera, 'cameraSn');
    const changes = {
      endpoint: values.endpoint
    }
    return formSubmit(updateCamera, { clientId,targetClientId, cameraSn, changes })
      .then(() => history.push(ROUTES.CAMERA))
  };

  render() {
    const { camera, cameraDetailsStatus } = this.props
    const initialValues = camera ? {
      ...camera
    } : null
    
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.CAMERA}>&laquo; Back</Link></p>
          <PageContentTitle>Edit a camera</PageContentTitle>
          {API_PENDING === cameraDetailsStatus && <Spinner />}
          {API_SUCCESS === cameraDetailsStatus && <CameraForm initialValues={initialValues} onSubmit={this.handleSubmit} />}
          {API_FAIL === cameraDetailsStatus && <h2>Camera Sn is invalid</h2>}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  camera: cameraDetailsSelector,
  cameraDetailsStatus: cameraDetailsStatusSelector
})

export const actions = {
  getCamera,
  updateCamera
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(CameraEdit)



// WEBPACK FOOTER //
// ./src/pages/camera/camera-edit/index.js